import React, { useContext } from 'react';

import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { type PlanIframeProps } from 'Components/widgets/payment-info/buy-now-pay-later/BuyNowPayLater';
import { useFormikContext } from 'formik';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { useAppContext } from 'Context/ReactAppContext';
import { useRouter } from 'next/router';
import { extractPayload } from 'Views/account/pre-payment/PrePaymentView.utils';
import URI from 'urijs';
import { useSelector } from 'react-redux';
import { useUplift } from './useUplift';
import { trackUplift } from './UpliftForm.utils';

const getAttendeesQuery = (attendeesId: Array<string>) => `query { 
  attendees(attendeesIds: ["${attendeesId.join('","')}"]) {
          firstName
          lastName
          dateOfBirth
          mobilePhoneNumber
          email
          address {
            streetNumber
            streetName
            zipCode
            city
            stateOrDistrict
            countryCode
          }
      }
}`;

export const UpliftForm = ({ onLoaded, price, display }: PlanIframeProps) => {
  const {
    onBuyNowPayLaterComplete,
    currency,
    bookingResume: {
      attendees: attendeesResume = [],
      accommodations,
      transports,
      departureDate,
      arrivalDate,
      name,
    },
  } = useContext(PaymentInfoContext);
  const formik = useFormikContext();
  const router = useRouter();
  const {
    query: { a, bnpl, paymentStatus },
  } = router;

  const isProposalLoading = useSelector((state) => state.booking.isProposalLoading);

  const attendees = extractPayload(a) || [];

  const { isUserLogged, isUserQuickLogged } = useAppContext();

  const onTokenAvailable = () => {
    onBuyNowPayLaterComplete();
  };
  const onTokenRetrieved = (token: string) => {
    if (token) {
      formik.setFieldValue('token', token);
      formik.submitForm();
    }
  };

  const { data, isLoading: isAttendeesLoading } = useGQL({
    query: getAttendeesQuery(attendeesResume),
    ignore: !isUserLogged || attendeesResume.length === 0,
    cache: true,
  });

  const booking = {
    price,
    attendees: data?.attendees || (isUserQuickLogged ? attendeesResume : attendees) || [],
    accommodations,
    transports,
    departureDate,
    arrivalDate,
    name,
  };

  const { shouldDisplay } = useUplift({
    shouldInit: !isAttendeesLoading && !isProposalLoading,
    isPaymentPage: true,
    isReadyToDisplay: display,
    booking,
    currency,
    onTokenAvailable,
    onTokenRetrieved,
    onLoaded: (loaded: boolean) => {
      onLoaded(loaded);
      if (bnpl && paymentStatus) {
        trackUplift({ isErrored: true, errorMsg: paymentStatus });
        const newUri = new URI(router.asPath).removeQuery(['bnpl']);
        router.replace(newUri.toString());
      }
    },
  });

  return (
    <Capsule className={`${shouldDisplay ? 'block' : 'hidden'} my-40`}>
      <div id="uplift-container"></div>
    </Capsule>
  );
};
